/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Tab_UnreadInputs */

const vi_notif_tab_unread = /** @type {(inputs: Notif_Tab_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa đọc`)
};

/**

* @param {Notif_Tab_UnreadInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_tab_unread = /** @type {((inputs?: Notif_Tab_UnreadInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Tab_UnreadInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_tab_unread(inputs)
});